export const REPAIR_PROGRESS_MAPPING = {
  REPAIR_BOOKED: 'Scheduled',
  VEHICLE_IN: 'Vehicle In',
  REPAIR_STARTED: 'Repair Started',
  REPAIR_COMPLETED: 'Repair Completed',
  VEHICLE_OUT: 'Vehicle Out'
};
